module.exports = "/static/assets/c3421543ab6c9e154f4294257ce0d078.svg";